// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"PageHeader_pageHeader__3XA5L","pageHeaderHeading":"PageHeader_pageHeaderHeading__2_pdw"};